export enum ActionType {
  INSTALL_RATE = 'I',
  TRANSFER_RATE = 'T',
  REMOVE_RATE = 'R',
}
